import Button from "@mui/material/Button";
import React from "react";

const CustomButton = ({ children, color = "primary", ...props }) => {
    return (
        <Button
            {...props}
            color={color}
            sx={{
                textTransform: "none",
                ...props.sx
            }}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
